import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import useMediaQuery from '@mui/material/useMediaQuery';

import { inicioService } from '../Services/Form';
import { IDataUser } from '../Interfaces/IProfile';
import LoadingAllScreen from '../Components/LoadingAllScreen/LoadingAllScreen';
import ModalReniciarUsuario from '../Components/ModalReiniciarUsuario/ModalReiniciarUsuario';

// import atrasIcon from '../Shared/Images/atras-icon.png';
// import profileImg from '../Shared/Images/profile.png';

import './Styles/Profile.css';

interface IUsuarioPerfil {
  usuario: any;
  perfil: any;
  handlerActualizar: () => void;
}

const Profile = () => {
  const [openModalReiniciar, setOpenModalReiniciar] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [dataUser, setDataUser] = useState<IDataUser>({
    nombres: '',
    correo: '',
    opcionReiniciar: false
  });
  const navigate = useNavigate();  
  const isMobile = useMediaQuery("(max-width:768px)");

  const value = localStorage.getItem('user');
  let user = typeof value === 'string' ? JSON.parse(value) : '';

  const getInitials = (name: string) => {
  if (!name) return '?';
  return name
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  };

  const displayName = dataUser.nombres || user?.nombres || '';
  const displayEmail = dataUser.correo || user?.correo || '';

  // const preloadData = {
  //   usuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
  //   Nombres: user.nombres,
  //   Correo: user.correo,
  //   Objetivo: user.objetivo,
  // };

  // const [nombres, setNombres] = useState<string>(preloadData.Nombres);
  // const [correo, setCorreo] = useState<string>(preloadData.Correo);
  // const matches = useMediaQuery('(max-width: 650px)');
  const handleLogout = () => {
    // localStorage.removeItem('user');
    localStorage.clear();
    navigate('/login');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    inicioService({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
    })
      .then((res) => {
        setDataUser({
          correo: res.data.data.correo,
          nombres: res.data.data.nombres,
          opcionReiniciar: res.data.data.opcionReiniciar,
        })
      })
      .catch(() => {
        toast.error("Se produjo un error al iniciar");
      }).
      finally(() => {
        setLoading(false);
      })
  }, []);  
  
  if (loading) return <LoadingAllScreen />;

  return (
    <div className="prof-page">
      {/* Header */}
      <div className="prof-header" style={!isMobile ? { marginTop: '5vh'} : {}}>
        <button className="prof-back-btn" onClick={() => navigate('/')}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="prof-header-text">
          <span className="prof-header-label">Tu cuenta</span>
          <h2 className="prof-header-title">Mi Perfil</h2>
        </div>
      </div>

      {/* Avatar Card */}
      <div className="prof-card">
        <div className="prof-avatar">
          <span className="prof-avatar-initials">{getInitials(displayName)}</span>
        </div>
        <h3 className="prof-name">{displayName}</h3>
        <p className="prof-email">{displayEmail}</p>
      </div>

      {/* Menu */}
      <div className="prof-menu">
        <div className="prof-menu-label">Ajustes</div>

        <button className="prof-menu-item" onClick={() => navigate('/changepassword')}>
          <span className="prof-menu-icon prof-menu-icon--key">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </span>
          <span className="prof-menu-item-text">Cambiar contraseña</span>
          <span className="prof-menu-chevron">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </span>
        </button>

        {dataUser.opcionReiniciar && (
          <button className="prof-menu-item" onClick={() => setOpenModalReiniciar(true)}>
            <span className="prof-menu-icon prof-menu-icon--reset">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10" />
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
              </svg>
            </span>
            <span className="prof-menu-item-text">Reiniciar Usuario</span>
            <span className="prof-menu-chevron">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </span>
          </button>
        )}

        <button className="prof-menu-item" onClick={handleLogout}>
          <span className="prof-menu-icon prof-menu-icon--logout">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </span>
          <span className="prof-menu-item-text">Cerrar Sesión</span>
          <span className="prof-menu-chevron">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </span>
        </button>
      </div>

      <ModalReniciarUsuario
        isOpen={openModalReiniciar}
        setIsOpen={setOpenModalReiniciar}
      />
    </div>
  );
};
export default Profile;